import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { QrCode, CheckCircle, ArrowLeft, Sparkles } from 'lucide-react'
import { Button } from '../components/ui/Button'

export default function PortalQrPage() {
  const [params] = useSearchParams()
  const [code, setCode] = useState<string>('')

  useEffect(() => {
    const c = params.get('code')
    if (c) setCode(c)
  }, [params])

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-red-50 to-pink-50 dark:from-gray-900 dark:via-gray-900 dark:to-gray-800 flex items-center justify-center p-4">
      <div className="w-full max-w-lg">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-2xl bg-gradient-to-br from-orange-500 to-red-500 mb-4 shadow-lg">
            <Sparkles className="h-10 w-10 text-white" />
          </div>
          <h1 className="text-3xl font-bold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent mb-2">
            Check-In Code
          </h1>
          <p className="text-gray-600 dark:text-gray-400">
            Show this to staff when you arrive
          </p>
        </div>

        {/* QR Code Card */}
        <div className="card border-2 border-orange-200 dark:border-orange-800 shadow-2xl">
          <div className="card-body text-center space-y-6">
            {/* QR Icon */}
            <div className="flex justify-center">
              <div className="p-6 rounded-2xl bg-gradient-to-br from-orange-100 to-red-100 dark:from-orange-500/20 dark:to-red-500/20">
                <QrCode className="h-24 w-24 text-orange-600 dark:text-orange-400" />
              </div>
            </div>

            {/* Code Display */}
            <div className="space-y-2">
              <p className="text-sm font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wide">
                Your Code
              </p>
              <div className="p-6 rounded-xl bg-gradient-to-br from-orange-50 to-red-50 dark:from-orange-500/10 dark:to-red-500/10 border-2 border-orange-200 dark:border-orange-800">
                <div className="text-5xl font-mono font-bold tracking-widest bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">
                  {code || '------'}
                </div>
              </div>
            </div>

            {/* Instructions */}
            <div className="flex items-start gap-3 p-4 bg-blue-50 dark:bg-blue-500/10 border border-blue-200 dark:border-blue-800 rounded-xl text-left">
              <CheckCircle className="h-5 w-5 text-blue-600 dark:text-blue-400 mt-0.5 flex-shrink-0" />
              <div className="flex-1 text-sm">
                <p className="font-semibold text-blue-900 dark:text-blue-100 mb-1">Check-In Instructions</p>
                <ul className="text-blue-800 dark:text-blue-300 space-y-1">
                  <li>• Present this code to staff at reception</li>
                  <li>• Code is valid for your booking time</li>
                  <li>• Arrive 5-10 minutes before your booking</li>
                </ul>
              </div>
            </div>

            {/* Actions */}
            <div className="pt-4 border-t border-gray-200 dark:border-gray-800 space-y-3">
              <Button
                onClick={() => window.history.back()}
                variant="outline"
                className="w-full flex items-center justify-center gap-2"
              >
                <ArrowLeft className="h-4 w-4" />
                Back to Bookings
              </Button>
              <p className="text-xs text-gray-500 dark:text-gray-500">
                Keep this screen accessible for check-in
              </p>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-6 text-sm text-gray-600 dark:text-gray-400">
          <p>Powered by <span className="font-semibold bg-gradient-to-r from-orange-600 to-red-600 bg-clip-text text-transparent">StudioManager 360</span></p>
        </div>
      </div>
    </div>
  )
}
